import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { ufoExperiences } from '../../util/analytics';
import LoadingEmojiComponent from '../common/LoadingEmojiComponent';
import { LoadingItem } from './EmojiPickerVirtualItems';
import { emojiPicker } from './styles';
import { UfoErrorBoundary } from '../common/UfoErrorBoundary';

const emojiPickerModuleLoader = () => import(
/* webpackChunkName:"@atlaskit-internal_emojiPickerComponent" */
'./EmojiPickerComponent');

const emojiPickerLoader = () => emojiPickerModuleLoader().then(module => module.default);

export class EmojiPickerInternal extends LoadingEmojiComponent {
  // state initialised with static component to prevent
  // rerender when the module has already been loaded
  constructor(props) {
    super(props, {});

    _defineProperty(this, "state", {
      asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent
    });

    ufoExperiences['emoji-picker-opened'].start();
  }

  asyncLoadComponent() {
    emojiPickerLoader().then(component => {
      EmojiPickerInternal.AsyncLoadedComponent = component;
      this.setAsyncState(component);
    });
  }

  renderLoading() {
    const item = new LoadingItem();

    const handlePickerRef = ref => {
      if (this.props.onPickerRef) {
        this.props.onPickerRef(ref);
      }
    };

    ufoExperiences['emoji-picker-opened'].markFMP();
    return jsx("div", {
      css: emojiPicker,
      ref: handlePickerRef
    }, item.renderItem());
  }

  renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
    const {
      emojiProvider,
      ...otherProps
    } = this.props;
    return jsx(UfoErrorBoundary, {
      experiences: [ufoExperiences['emoji-picker-opened']]
    }, jsx(EmojiPickerComponent, _extends({
      emojiProvider: loadedEmojiProvider
    }, otherProps)));
  }

}
const EmojiPicker = withAnalyticsEvents()(EmojiPickerInternal);
export default EmojiPicker;